import React, { Suspense } from "react";
import ReactDOM from "react-dom";
import "bootswatch/dist/zephyr/bootstrap.min.css";
import "./index.css";
import App from "./App";
import { I18nextProvider } from "react-i18next";
import i18next from "i18next";

import global_es from "./translations/es.json";
import global_en from "./translations/en.json";

import { FirebaseAppProvider } from "reactfire";
import { firebaseConfig } from "firebase-config";

i18next.init({
  interpolation: { escapeValue: false },
  lng: "es",
  resources: {
    es: { global: global_es },
    en: { global: global_en },
  },
});

ReactDOM.render(
  <FirebaseAppProvider firebaseConfig={firebaseConfig}>
    <Suspense fallback={"Contectando la app..."}>
      <React.StrictMode>
        <I18nextProvider i18n={i18next}>
          <App />
        </I18nextProvider>
      </React.StrictMode>
    </Suspense>
  </FirebaseAppProvider>,
  document.getElementById("root")
);
